import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import ResourceCloudSelectionDialog from '@/components/ResourceCloudSelectionDialog/index.vue';
import categoryMixin from '@/views/creative/mixin/category.js';
import CropperDialog from '@pt/components/cropper-dialog/index';
import { transBase64FromImageUrl } from '@/utils/index.js';
import { validateFrameSequence, validateDragonBones } from '@/views/creative/utils/resource-validator.js';
import resourceMixin from '@/views/creative/mixin/resource.js';
import { uploadFile } from '@/api/common/upload';

export default {
  mixins: [categoryMixin, resourceMixin],

  components: {
    ResourceCloudSelectionDialog: ResourceCloudSelectionDialog,
    CropperDialog: CropperDialog
  },

  props: {
    cropperSwitch: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      cropperDialogVisible: false,
      cropper: {},
      currentFile: {}
    };
  },


  computed: _extends({}, mapState({
    category: function category(state) {
      return state.creative.template.currentCategory || {};
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    }
  }), {
    cloudResourcesDialog: function cloudResourcesDialog() {
      return this.$store.state.creative.template.cloudResourcesDialog;
    },
    query: function query() {
      var query = {};

      if (this.category && this.category.res_cat1_id) {
        query.cat1_ids = [this.category.res_cat1_id];
      }
      if (this.category && this.category.res_cat2_id) {
        query.cat2_ids = [this.category.res_cat2_id];
      }

      return query;
    },
    formItem: function formItem() {
      return {
        cat2_ids: {
          // 实现方式不等于 0 就禁用对应控件
          disabled: this.category.res_cat2_id !== 0
        },
        cat1_ids: {
          // 实现类型不等于 0 就禁用对应控件
          disabled: this.category.res_cat1_id !== 0
        }
      };
    },


    visible: {
      get: function get() {
        return this.cloudResourcesDialog.visible;
      },
      set: function set(val) {
        if (val === false) {
          this.close();
        }
      }
    }
  }),

  methods: {
    uploadFile: uploadFile,

    handleSubmit: function handleSubmit(ids, file) {
      // 原来是多选，改成单选
      this.currentFile = file;
      if (this.isImage) {
        this.cropperUpload(file.file_url);
      } else {
        this.compareResource(file);
      }
    },
    cookResource: function cookResource(fileList) {
      var _this = this;

      var resourceList = fileList.map(function (file) {
        var resource = {
          file_name: file.file_origin_name,
          prefix: _this.category.prefix,
          resource_type: _this.category.resource_type,
          file_url: file.file_url,
          file: file.file_path,
          file_md5: file.md5,
          res_id: file.id,
          res_tag_ids: Array.isArray(file.tag_ids) ? file.tag_ids.join(',') : file.tag_ids,
          resource_origin: 'cloud',
          isRepository: _this.category.isRepository,
          category_id: _this.category.id

          // 预览链接
        };if (Array.isArray(file.preview_urls)) {
          resource.preview_urls = file.preview_urls;
        }

        // 预览链接对应的文件信息
        if (Array.isArray(file.file_list)) {
          resource.preview_extras = file.file_list.map(function (item) {
            return _JSON$stringify(_extends({
              file_name: item.name,
              file_size: item.size
            }, item));
          });
        }

        return resource;
      });

      return resourceList;
    },
    addResource: function addResource(fileList) {
      var _this2 = this;

      var resourceList = this.cookResource(fileList);
      resourceList.forEach(function (resource) {
        _this2.$store.dispatch('creative/template/addResource', _extends({}, resource, {
          is_default: 0
        }));
      });
      this.close();
    },
    close: function close() {
      this.$store.commit('creative/template/closeCloudResourcesDialog');
      this.$store.commit('creative/template/updateCurrentCategory', null);
      this.$store.commit('creative/template/updateCurrentResource', null);
    },
    cropperUpload: function cropperUpload(fileUrl) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var dataURL, fileTypeParts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return transBase64FromImageUrl(fileUrl);

              case 3:
                dataURL = _context.sent;
                fileTypeParts = fileUrl.split('.')[fileUrl.split('.').length - 1].indexOf('png') === -1 ? 'jpeg' : 'png';

                _this3.cropper = {
                  img: dataURL,
                  outputType: fileTypeParts
                };
                if (_this3.resourceMetaData) {
                  _this3.cropper = _extends({}, _this3.cropper, {
                    autoCropWidth: _this3.resourceMetaData.width,
                    autoCropHeight: _this3.resourceMetaData.height
                  });
                }
                _this3.cropperDialogVisible = true;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this3.$message.error('读取图片失败');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 10]]);
      }))();
    },
    handleUploadSuccess: function handleUploadSuccess(_ref) {
      var file = _ref.file;

      this.addResource([_extends({}, this.currentFile, file, {
        file_origin_name: file.origin_name,
        file_url: file.url
      })]);
    },
    resourceValidator: function resourceValidator(_ref2) {
      var newFiles = _ref2.newFiles,
          oldFiles = _ref2.oldFiles;

      var files = newFiles;

      if (this.isFrameSequence) {
        var _validateFrameSequenc = validateFrameSequence({ files: files, oldFiles: oldFiles }),
            _validateFrameSequenc2 = _slicedToArray(_validateFrameSequenc, 2),
            valid = _validateFrameSequenc2[0],
            errors = _validateFrameSequenc2[1];

        if (!valid) this.$message.error(errors[0].message);
        return valid;
      }

      if (this.isDragonBones) {
        var _validateDragonBones = validateDragonBones({
          files: files,
          oldFiles: oldFiles,
          type: this.category.lg_type
        }),
            _validateDragonBones2 = _slicedToArray(_validateDragonBones, 2),
            _valid = _validateDragonBones2[0],
            _errors = _validateDragonBones2[1];

        if (!_valid) this.$message.error(_errors[0].message);
        return _valid;
      }

      return true;
    },
    compareResource: function compareResource(file) {
      var valid = this.resourceValidator({
        newFiles: file.preview_urls,
        oldFiles: this.basicResource.preview_urls_for_live_preview
      });
      if (valid) {
        this.addResource([file]);
      }
    }
  }
};